import React, { useEffect } from 'react'
import { CustomerModel, ServiceModelDto } from '../../../../../domain/models'
import { useModalBox, useOnChangeDetect } from '../../../../contexts'
import { LabelCard } from '../../../../pages/my-clients/styles'
import Button from '../../../button'
import Input from '../../../input'
import Textarea from '../../../textarea'
import { FormStyled, Row } from './style'
import { useAlert } from 'react-alert'
import { useForm } from '../../../../hooks'
import { createNewService, updateService } from '../../../../../main/usecases'
import moment from 'moment'

type FormModel = {
  customer?: CustomerModel
  currentService: ServiceModelDto | undefined
  setSelectService: (e: any) => void
}

const ServiceForm = ({
  customer,
  currentService,
  setSelectService
}: FormModel) => {
  const { modalClose } = useModalBox()
  const { setRefresh } = useOnChangeDetect()
  const alert = useAlert()
  const startDateInput = useForm()
  const finalDateInput = useForm()
  const serviceInput = useForm()
  const demandasInput = useForm()

  useEffect(() => {
    startDateInput.setValue(moment().format('yyyy-MM-DD'))
    if (currentService) {
      startDateInput.setValue(currentService?.dataServico)
      finalDateInput.setValue(currentService?.dataFinal)
      serviceInput.setValue(currentService?.titulo)
      demandasInput.setValue(currentService?.demandaObjetivo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentService])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    try {
      const body = {
        cliente: {
          cdCliente: customer?.cdCliente
        },
        dataServico: startDateInput?.value,
        dataFinal: finalDateInput?.value,
        demanda: demandasInput?.value,
        tituloServico: serviceInput?.value,
        demandaObjetivo: demandasInput?.value
      }
      if (currentService) {
        const resp = await updateService(currentService?.cdServico).update(body)
        alert.show('Serviço cadastrado.', {
          type: 'success',
          timeout: 4000
        })
        console.log(resp)
        setSelectService(resp)
      } else {
        await createNewService().post(body)
        alert.show('Serviço cadastrado.', {
          type: 'success',
          timeout: 4000
        })
      }
      modalClose(true)
      setRefresh((prev: boolean) => !prev)
    } catch (error) {
      alert.show((error as Error).message || 'Ao Ao criar serviço.', {
        type: 'success',
        timeout: 4000
      })
    }
  }

  return (
    <FormStyled className="validate-report-modal" onSubmit={onSubmit}>
      <div>
        <Row>
          <LabelCard>
            <label>Paciente</label>
            <p>{customer?.nome}</p>
          </LabelCard>
        </Row>
        <Row>
          <LabelCard>
            <label>CPF</label>
            <p>{customer?.cpf}</p>
          </LabelCard>
        </Row>
        <Row className="d-flex">
          <Input
            labelColor="#4F4F4F"
            label="Data de Ínicio*"
            name="startDate"
            placeholder="00/00/0000"
            type="date"
            style={{ width: '95%' }}
            required
            {...startDateInput}
          />
          <Input
            labelColor="#4F4F4F"
            label="Data Final"
            name="finalDate"
            placeholder="00/00/0000"
            type="date"
            style={{ width: '100%' }}
            // required
            {...finalDateInput}
          />
        </Row>
        <Row>
          <Input
            labelColor="#4F4F4F"
            label="Nome do Serviço*"
            name="serviceName"
            placeholder="Digite o nome do serviço"
            type="text"
            style={{ width: '100%' }}
            required
            {...serviceInput}
          />
        </Row>
        <Row className="d-flex">
          <Textarea
            label="Demandas e objetivos"
            labelColor="#4F4F4F"
            name="resume"
            placeholder="Text"
            {...demandasInput}
          />
        </Row>
      </div>
      <Row className="button-container">
        <label className="required-msg">*Campos obrigatórios</label>
        <div className="buttons">
          <button
            className="access-complete-register-button"
            onClick={() => modalClose(true)}
          >
            Cancelar
          </button>
          <Button>{currentService ? 'Salvar' : 'Criar'}</Button>
        </div>
      </Row>
    </FormStyled>
  )
}

export default ServiceForm
